module.exports = __webpack_public_path__ + "img/main-info.81f96042.png";